import {
  FETCH_PAYMENTMODE_INIT_ACTION,
  FETCH_PAYMENTMODE_SUCCESS_ACTION,
  FETCH_PAYMENTMODE_FAIL_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_PAYMENTMODE_SUCCESS_ACTION:
      return {
        ...state,
        PaymentmodeList: action.payload.rows,
        PaymentmodeCount: action.payload.count
      };

    default:
      return {
        ...state
      };
  }
}
